import { Environment } from '../environment';

// eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/typedef
const _CMS_LANGUAGE = (window as any)._CMS_LANGUAGE;
// eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/typedef
const _CMS_USERIP = (window as any)._CMS_USERIP;

// eslint-disable-next-line @typescript-eslint/naming-convention
declare const ENVIRONMENT_NAME: 'staging' | 'production';
// eslint-disable-next-line @typescript-eslint/naming-convention
declare const DEVELOPMENT_SERVER: boolean | undefined;

export const environmentShared: Omit<Environment, 'brandName' | 'device'> = {
  locale: _CMS_USERIP,
  language: _CMS_LANGUAGE,
  environment: ENVIRONMENT_NAME,
  localServer: Boolean(DEVELOPMENT_SERVER)
};
